import './DownsideBackground.css';
import { Link } from 'react-router-dom';
import backgroundFooter from '../imagesHome/background_footer.png';

const DownsideBackground = () => {
  return (
   <>
   
   
   
        {/* CTA FINAL - Modernized */}
  <section className="final-cta-modern">

  <div className="final-cta-content">
    <h2>Invata contabilitatea altfel</h2>

  

    <Link to="/quiz-start" className="final-cta-button">
      Incepe acum
    </Link>
  </div>

  <div className="cta-footer-art">
    <img
      src={backgroundFooter}
      alt=""
      className="cta-footer-art__image"
    />
  </div>

</section>


</>
  );
};

export default DownsideBackground;